<template>
    <div>
        <card-header title="Pending Payment Plans" icon="fa-timer"/>

        <card-body>
            <card-list>
                <template v-if="currentUser.role === 'dev' || currentUser.role === 'admin'">
                    <subheader-list-item title="Pending Plans" icon="fa-history" :badge="pendingPlans.length"/>
                    <plan-tile
                        v-for="plan in pendingPlans"
                        :card="card"
                        :plan="plan"
                        :active="child && child.definition.component === 'activate-plan' && parseInt(child.props.planId) === plan.id"
                        @click="$openCard('activate-plan', {planId: plan.id}, card)"
                    />
                </template>


            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import PlanTile from "@/components/tiles/PlanTile";

    import {client as http} from '../../http_client';
    import {mapGetters} from "vuex";

    export default {
        components: {PlanTile, CardHeader, CardBody, CardToolbar, CardList, SubheaderListItem},
        props: ['card', 'child'],
        data() {
            return {
                pendingPlans: []
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            loadPlans: function (force) {
                this.$emit('loading', true);

                http.get('payment-plans/submissions', {force}).then(response => {
                    this.pendingPlans = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            reload: function () {
                console.log('Reloading plans...');
                this.loadPlans(true);
            }
        },
        mounted: function () {
            this.loadPlans();
        }
    }
</script>
